export const weekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

export function hoursToTimeString(hours: number | null | undefined, allowOutsideClock = false): string | null {
    if (hours === null || hours === undefined) {
        return null;
    }

    const absHours = Math.abs(hours);

    if (!allowOutsideClock && absHours > 24) {
        return null;
    }

    const h = Math.floor(absHours);
    const m = Math.round((absHours - h) * 60);

    return (hours < 0 ? '-' : '') + h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
}

export function timeStringToHours(
    timeString: string | undefined,
    allowOutsideClock = false,
    allowNegative = false,
): number | null {
    if (timeString === undefined) {
        return null;
    }

    const re = /^(-)?(\d+):(\d+)/;
    const found = timeString.trim().replaceAll(' ', '').match(re);

    if (!found) {
        return null;
    }

    const negative = found[1] === '-';

    const h = parseInt(found[2], 10);
    const m = parseInt(found[3], 10);

    if (!allowOutsideClock && (h < 0 || h > 23 || m < 0 || m > 59)) {
        return null;
    }

    if (negative && allowNegative) {
        return (h + m / 60) * -1;
    }

    return h + m / 60;
}

export function minutesToTimeString(minutes: number | null | undefined, allowOutsideClock = false): string | null {
    if (minutes === null || minutes === undefined) {
        return null;
    }

    if (!allowOutsideClock && (minutes < 0 || minutes > 23 * 60 + 59)) {
        return null;
    }

    const h = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
}

export function timeStringToMinutes(timeString: string | undefined): number | null {
    if (timeString === undefined) {
        return null;
    }

    const re = /^(\d+):(\d+)/;
    const found = timeString.trim().replaceAll(' ', '').match(re);

    if (!found) {
        return null;
    }

    const h = parseInt(found[1], 10);
    const m = parseInt(found[2], 10);

    if (h < 0 || h > 23 || m < 0 || m > 59) {
        return null;
    }

    return h * 60 + m;
}
